import { render, staticRenderFns } from "./adminlogin.vue?vue&type=template&id=2b39eb30&scoped=true"
import script from "./adminlogin.vue?vue&type=script&lang=js"
export * from "./adminlogin.vue?vue&type=script&lang=js"
import style0 from "./adminlogin.vue?vue&type=style&index=0&id=2b39eb30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b39eb30",
  null
  
)

export default component.exports